import HallModel from '../Model/HallModel';
import UserModel from '../Model/UserModel';
import DebugModel from '../Model/DebugModel';
import HistoryModel from '../Model/HistoryModel';
import SettingModel from '../Model/SettingModel';
import LobbyJackpotModel from '../Model/LobbyJackpotModel';

export type ModelType = {
    [ModelName.User]: UserModel;
    [ModelName.Hall]: HallModel;
    [ModelName.History]: HistoryModel;
    [ModelName.Setting]: SettingModel;
    [ModelName.Jackpot]: LobbyJackpotModel;
    [ModelName.Debug]: DebugModel;
};

export enum ModelName {
    User = 'User',
    Hall = 'Hall',
    Setting = 'Setting',
    History = 'History',
    Debug = 'Debug',
    Jackpot = 'Jackpot',
}

export type ModelKeys = keyof ModelType;
